import {DrillHoleConfiguration} from "@/Models/DrillHoleConfigurations/DrillHoleConfiguration";

export default class EdgeDrillHoleConfiguration implements DrillHoleConfiguration {
	get_input_keys(): string[] {
		return [
			'drillHoleOffset',
			'drillHoleDiameter',
		];
	}
}
